import { RiPhoneLine } from 'react-icons/ri';
import { RiTimeLine } from 'react-icons/ri';
//
import { RiVkLine } from 'react-icons/ri';
import { RiWhatsappLine } from 'react-icons/ri';
import { RiInstagramLine } from 'react-icons/ri';

export const contactData = [
  {
    id: 1,
    icon: <RiPhoneLine />,
    url: 'tel:+78432587426',
    name: '+7-843-258-74-27',
    desc: 'Телефон',
  },
  {
    id: 2,
    icon: <RiTimeLine />,
    name: 'Пн - Вс 08:00 - 23:00',
    desc: 'Режим работы',
    url: false,
  },
];

export const sotcialData = [
  {
    id: 1,
    icon: <RiVkLine />,
    url: 'https://vk.com/sparta_kazan_paintball',
    name: 'vk',
  },
  {
    id: 2,
    icon: <RiInstagramLine />,
    url: 'https://instagram.com/spartakzn?igshid=qtd68lc1fpia',
    name: 'instagram',
  },
  {
    id: 2,
    icon: <RiWhatsappLine />,
    url: 'https://wa.me/+79625522333',
    name: 'Whatsapp',
  },
];
// krla
{
  /* <iframe
  src="https://yandex.ru/map-widget/v1/?um=constructor%3A364cff6d090674a9e6901aa68200441a85b6a66a85fff970fb3883b162b0267f&amp;source=constructor"
  width="426"
  height="400"
  frameborder="0"
></iframe>; */
}
// dubr
{
  /* <iframe
  src="https://yandex.ru/map-widget/v1/?um=constructor%3Aa833fba24ec29db23c02cfacbc891476b8c1e75e159fe7fd3dcb33d93d1db388&amp;source=constructor"
  width="569"
  height="400"
  frameborder="0"
></iframe>; */
}
// novo
{
  /* <iframe
  src="https://yandex.ru/map-widget/v1/?um=constructor%3Afca439c5c3d3d3b51ed8fa9ecf8d728bf188b07f4ac36378afdbf84ae58d6ea3&amp;source=constructor"
  width="500"
  height="400"
  frameborder="0"
></iframe>; */
}

// salmachi
{
  /* <iframe
  src="https://yandex.ru/map-widget/v1/?um=constructor%3A4244aa07517ff3b6f078f9a9824f544444c6f2fb0fb24913e2dea71e016cf589&amp;source=constructor"
  width="500"
  height="400"
  frameborder="0"
></iframe>; */
}
